import styled from 'styled-components'

interface Props {
    isActive: boolean
    componentId: string
    isNested: boolean
    position: 'left' | 'right'
}

export const StyledPopup = styled.div<Props>`
    position: relative;
    z-index: 1000;
    cursor: pointer;
    line-height: 0;

    div#StyledPopupMainPopup-${p => p.componentId} {
        user-select: none;
        display: ${p => (p.isActive ? 'block' : 'none')};
        position: absolute;
        bottom: ${p => (p.isNested ? '165%' : '150%')};
        ${p => p.position}: ${p => (p.isNested ? '-8px' : '-14px')};
        padding: 13px;
        border-radius: 6px;
        background: ${p => p.theme.popupBackgroundColor};

        &::after {
            content: '';
            width: 12px;
            height: 12px;
            background: ${p => p.theme.popupBackgroundColor};
            position: absolute;
            bottom: -4px;
            ${p => p.position}: 17px;
            transform: rotate(45deg);
        }
    }
`
